import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/storage";
import "firebase/analytics";
import 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyCnHYpR0uSDRH8RaflvlHFKYWNzOLvi8BY",
    authDomain: "didi-shark-tank.firebaseapp.com",
    projectId: "didi-shark-tank",
    storageBucket: "didi-shark-tank.appspot.com",
    messagingSenderId: "218392643203",
    appId: "1:218392643203:web:0d31130ed753800c8b3db6",
    measurementId: "G-2EHVMT5ZC4"
};

var firebaseApp = firebase.initializeApp(firebaseConfig);

var db = firebaseApp.firestore();
var storage = firebaseApp.storage();
const auth = firebaseApp.auth()
firebaseApp.analytics();

export { db, storage, auth }